import type { PurchaseDemandVo, ServiceSpecialVo } from "@zhihaoscm/entity";
import { intendService } from "@/api/services/intendService";
import { message } from "antd";
import { customerService } from "@/api/services/customerService";
import { projectService } from "@/api/services/projectService";
import { YES_OR_NO } from "@/meta/common";
import { INTEND_STATE } from "@/meta/purchase/intend";
import type { AssignForm, AuditForm, GenerateProjectParams, StrandingForm } from "@/entity/purchasing/intend";

class IntendedDemandManage {
    /**获取指派页面数据 */
    async getOfficers(query: string): Promise<ServiceSpecialVo[]> {
        try {
            return await intendService.getOfficer(query);
        } catch (e: unknown) {
            console.log(e);
            return [];
        }
    }
    /**获取根据id获取意向数据 */
    async getIntendedDemandById(id: number) {
        try {
            const data = await intendService.get(id);
            return data as PurchaseDemandVo;
        } catch (e) {
            console.error(e);
        }
    }
    /**获取当前专员 */
    async getCurOfficer(id: number) {
        const purchaseDemandVo = (await this.getIntendedDemandById(id)) as PurchaseDemandVo;
        return purchaseDemandVo.user?.id;
    }
    /**指定专员 */
    async designateOfficer(form: AssignForm) {
        try {
            const data = await intendService.designate(form);
            message.success("指定专员成功");
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**搁浅意向 */
    async strandIntend(form: StrandingForm) {
        try {
            const data = await intendService.strandIntend(form);
            message.success("已搁浅");
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**开始意向 */
    async startIntend(id: number) {
        try {
            const data = await intendService.startIntend(id);
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**获取项目专员数据 */
    async getProjectOfficers() {
        try {
            const data = await projectService.getSpecialsSelector("");
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**生成项目 */
    async createProject(form: GenerateProjectParams) {
        try {
            const data = await projectService.generateProject(form);
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**提交审核 */
    async submitAudit(id: number) {
        try {
            const data = await intendService.submitAudit(id);
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**审核意向 */
    async auditIntend(form: AuditForm) {
        try {
            const data = await intendService.auditIntend(form);
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    /**重置意向 */
    async resetIntend(id: number) {
        try {
            const data = await intendService.resetIntend(id);
            return data;
        } catch (e) {
            console.error(e);
        }
    }

    /**关闭意向 */
    async closeIntend(id: number) {
        try {
            const data = await intendService.closeIntend(id);
            return data;
        } catch (e) {
            console.error(e);
        }
    }
}

class BooleanStateHolder {
    // 获取第一个属性
    getProperty1(state: number): boolean {
        return (state & 1) !== 0;
    }

    // 获取第二个属性
    getProperty2(state: number): boolean {
        return (state & 2) !== 0;
    }

    // 获取第三个属性
    getProperty3(state: number): boolean {
        return (state & 4) !== 0;
    }
}

export const booleanStateHolder = new BooleanStateHolder();

export const getCustomerOptions = async () => {
    // 供应商选择沿用旧版 role-select 的印章管理员筛选契约。
    const allCustomer = await customerService.customerSelector({ isSealAdmin: YES_OR_NO.YES.code }).catch(() => []);
    return allCustomer.map(item => {
        return {
            label: item.nickName,
            value: item.id
        };
    });
};

export const intendedDemandManage = new IntendedDemandManage();

// 计算操作按钮是否展示
export const isShowBtn = (state: number = 0, opName: string) => {
    let stateArr: number[] = [];
    switch (opName) {
        case "指派":
            stateArr = [
                INTEND_STATE.STAY_ASSIGN.code,
                INTEND_STATE.PENDING.code,
                INTEND_STATE.REJECTED.code,
                INTEND_STATE.PROCESSING.code
            ];
            break;
        case "开始":
            stateArr = [INTEND_STATE.PENDING.code];
            break;
        case "提交审核":
            stateArr = [INTEND_STATE.PROCESSING.code];
            break;
        case "修改":
            stateArr = [
                INTEND_STATE.STAY_ASSIGN.code,
                INTEND_STATE.PENDING.code,
                INTEND_STATE.REJECTED.code,
                INTEND_STATE.PROCESSING.code,
                INTEND_STATE.WAIT_CONFIRM.code
            ];
            break;
        case "搁浅":
            stateArr = [
                INTEND_STATE.PENDING.code,
                INTEND_STATE.REJECTED.code,
                INTEND_STATE.PROCESSING.code,
                INTEND_STATE.WAIT_CONFIRM.code
            ];
            break;
        case "审核":
            stateArr = [INTEND_STATE.WAIT_AUDIT.code];
            break;
        case "生成项目":
            stateArr = [INTEND_STATE.CONFIRMED.code];
            break;
        case "重置":
            stateArr = [INTEND_STATE.CONFIRMED.code, INTEND_STATE.STRANDING.code];
            break;
        case "关闭":
            stateArr = [INTEND_STATE.STRANDING.code];
    }
    return stateArr.includes(state);
};
